import { render } from "./main-top-bar.vue?vue&type=template&id=3a73d678&scoped=true&ts=true"
import script from "./main-top-bar.vue?vue&type=script&lang=ts"
export * from "./main-top-bar.vue?vue&type=script&lang=ts"

import "./main-top-bar.vue?vue&type=style&index=0&id=3a73d678&scoped=true&lang=css"

import exportComponent from "E:\\vs2019\\face-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a73d678"]])

export default __exports__